module.exports = __webpack_public_path__ + "img/model-placeholder.6c89d664.jpg";